var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginPasswordVisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.378272 9.19343C7.34494 1.12676 14.9716 1.2001 21.7916 9.19343C22.2316 9.70676 22.2316 10.3668 21.7916 10.7334C14.8983 18.8734 7.27161 18.8001 0.378272 10.7334C0.0116048 10.3668 0.0116048 9.70676 0.378272 9.19343ZM11.0849 5.6001C13.5783 5.6001 15.5583 7.5801 15.5583 10.0734C15.5583 12.4934 13.5783 14.4734 11.0849 14.4734C8.59161 14.4734 6.61161 12.4934 6.61161 10.0734C6.61161 7.5801 8.59161 5.6001 11.0849 5.6001Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0849 7.72656C12.4049 7.72656 13.4316 8.75323 13.4316 10.0732C13.4316 11.3199 12.4049 12.4199 11.0849 12.4199C9.76495 12.4199 8.73828 11.3199 8.73828 10.0732C8.73828 8.75323 9.76495 7.72656 11.0849 7.72656Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPasswordVisible);
export default __webpack_public_path__ + "static/media/login_password_visible.292a4148f8eccbe165f1a9fff22f28c2.svg";
export { ForwardRef as ReactComponent };